'use client';

import { Button } from '@gartner-digital-markets/nimbus-v3-ui';
import { cn } from '../ui/utils';

type ButtonVariant = 'default' | 'accent' | 'secondary' | 'outline';

interface SubmitButtonProps {
  text?: string;
  loadingText?: string;
  isLoading?: boolean;
  className?: string;
  variant?: ButtonVariant;
}

export const SubmitButton = ({
  text = 'Submit',
  loadingText = 'Submitting...',
  isLoading = false,
  className,
  variant = 'default',
}: SubmitButtonProps) => (
  <Button
    type="submit"
    variant={variant}
    loading={isLoading}
    disabled={isLoading}
    className={cn('h-10 px-4 text-base leading-6 font-semibold', className)}
    data-testid="bx-forms-submit-button"
  >
    {isLoading ? loadingText : text}
  </Button>
);
